<script lang="ts">
	import TextArea from '../atoms/TextArea.svelte'
	import { t } from '../../i18n/i18n'
	import { NotificationType } from '../types/notification'
	import { addNotification } from '../stores'
	import { getContext } from 'svelte'
	import { ButtonIcons, LotState } from '../types/enums'
	import ActualTargetComparison from '../organisms/ActualTargetComparison.svelte'
	import SecondaryButton from '../atoms/SecondaryButton.svelte'
	import type { Writable } from 'svelte/store'
	import type { Lot } from '../types/lot'
	import { type Offers, OfferState } from '../bid/types/offer'
	import type { ContactData } from '../types/contactData'
	import { saveOptimizerPublicComment } from '../bid/offerUtils'
	import OptimizerPagesTemplate from './OptimizerPagesTemplate.svelte'
	import type { Deal } from '../bid/types/deal'
	import { NextButtonWantedObject } from '../bid/types/nextButtonDto'
	import OfferInfo from '../bid/OfferInfo.svelte'

	const lot: Writable<Lot> = getContext('lot')
	const offers: Writable<Offers> = getContext('offers')
	const deal: Writable<Deal> = getContext('deal')

	export let optimizerContactData: ContactData

	if ($lot.state === LotState.OPTIMIZED && $deal.isRequestDirectlyAcceptedByOptimizer) {
		let notification = {
			message: $t('UI.Accepted.successful'),
			type: NotificationType.SUCCESS,
			timeout: 0,
			dismissible: false
		}
		addNotification(notification)
	}

	function sendSaveRequest() {
		saveOptimizerPublicComment($offers)
	}
</script>

<OptimizerPagesTemplate
	recipientData={optimizerContactData}
	projectNavigationCurrentId={$deal?.publicId}
	projectNavigationReturnUrl="/lots/won"
	projectNavigationWantedObject={NextButtonWantedObject.DEAL}
>
	{#if $lot?.state === LotState.OPTIMIZED}
		<OfferInfo onOptimizerPage />
	{/if}
	{#if $lot?.state === LotState.ACCOUNTING || $lot?.state === LotState.HANDLING || $lot?.state === LotState.COMPLETED}
		<div class="row">
			<div class="col-lg-12 col-sm-12">
				<ActualTargetComparison readOnly={$lot?.state !== LotState.HANDLING} />
			</div>
		</div>
		<div class="row">
			<div class="col-lg-12 col-xs-12">
				{#if $offers.material.offerState === OfferState.ACCEPTED}
					<TextArea
						id="optimizerPublicComment"
						bind:text={$offers.material.optimizerPublicComment}
						title={$t('UI.remarks.label')}
						placeholder={$t('UI.pubRemarks.placeholder.detailedInfo')}
					/>
				{:else if $offers.materialWithTransport.offerState === OfferState.ACCEPTED}
					<TextArea
						id="optimizerPublicComment"
						bind:text={$offers.materialWithTransport.optimizerPublicComment}
						title={$t('UI.remarks.label')}
						placeholder={$t('UI.pubRemarks.placeholder.detailedInfo')}
					/>
				{:else}
					<TextArea
						id="optimizerPublicComment"
						bind:text={$offers.transport.optimizerPublicComment}
						title={$t('UI.remarks.label')}
						placeholder={$t('UI.pubRemarks.placeholder.detailedInfo')}
					/>
				{/if}
				<div class="align-right" style="margin-top: 1.125rem">
					<SecondaryButton
						id="saveOptimizerCommentBtn"
						label={$t('UI.saveRemark')}
						leftIcon={ButtonIcons.CHECKMARK}
						on:click={sendSaveRequest}
					/>
				</div>
			</div>
		</div>
	{/if}
</OptimizerPagesTemplate>

<style lang="scss">
	@import '$styles/pubPage';
</style>
